import { createInvokeEpic } from '../../../signalr/createInvokeEpic'

import { fetchManagementReportDefinition } from './definition'

export default createInvokeEpic(
  'managementReports.fetch',
  fetchManagementReportDefinition
)
